import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { GeneralService } from 'src/app/services/general.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { environment } from 'src/environments/environment';
import { CommonMethodService } from '../common-method.service';
import { EActionTypes, EElementTypes, EUserFunctions } from '../enum';
import { ICountry, IGetPermissionMandatoryField, IState } from '../interface';

@Component({
    selector: 'app-tax-exempt',
    templateUrl: './tax-exempt.component.html',
    styleUrls: ['./tax-exempt.component.scss'],
    standalone: false
})
export class TaxExemptComponent implements OnInit {
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveForm: EventEmitter<any> = new EventEmitter<any>();
  @Input() moduleName;
  @Input() facilityId;
  @Input() taxExemptformObj;

  taxExemptForm: FormGroup;
  eNumActionTypes = EActionTypes;
  eNumElementTypes = EElementTypes;
  emailPattern = '^([\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)([\,\;]{1}[\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)*$';
  taxValidators: IGetPermissionMandatoryField;
  stateList = [];
  private defaultCountryId = environment.defaultCountryId;
  defaultCountry;
  countryList: ICountry[];
  public PhoneNumberMask: String = '(000)000-0000';
  modalRef: any;
  emptyStateList = false;
  viewRight: boolean;
  editRight: boolean;
  viewRightFalseMessage: string;
  editRightFalseMessage: string;

  @Input() isDisableResellerPermit: boolean = true;
  constructor(private fb: FormBuilder,
    public generalService: GeneralService,
    private userSessionService: UserSessionService,
    private modalService: BsModalService,
    private commonMethodService: CommonMethodService) { }

  ngOnInit() {
    let componentName = 'facops-merchandise-sales.component.html';
    if (this.moduleName == "AuctionManager") {
      componentName = 'facOps-auction-manager.component.html';
      this.viewRight = true;
      this.editRight = true;
    } else {
      this.getUserPermissions();
    }
    this.getMandatoryFields(componentName, 'taxExemptForm');
    this.taxExemptForm = this.fb.group({
      TaxIdentificationNumber: ['', [Validators.required]],
      CompanyName: [''],
      FirstName: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
      MiddleName: [''],
      LastName: ['', [Validators.required, this.generalService.noWhitespaceValidator]],
      Address: [''],
      City: [''],
      State: [''],
      Zip: [''],
      CountryId: [''],
      CellPhoneCountryId: [''],
      CellPhone: ['', [Validators.required, this.cellPhoneValidator]],
      HomePhoneCountryId: [''],
      HomePhone: [''],
      WorkPhoneCountryId: [''],
      WorkPhone: [''],
      Email: ['', [Validators.pattern(this.emailPattern)]],
      FaxCountryId: [''],
      Fax: [''],
    });
    if (this.isDisableResellerPermit) {
      if (this.taxExemptForm) {
        this.taxExemptForm.get('TaxIdentificationNumber').patchValue('');
        this.taxExemptForm.get('TaxIdentificationNumber').disable();
        this.taxExemptForm.get('TaxIdentificationNumber').setValidators(null);
        this.taxExemptForm.get('TaxIdentificationNumber').updateValueAndValidity();
      }
    } else {
      if (this.taxExemptForm) {
        this.taxExemptForm.get('TaxIdentificationNumber').enable();
        this.taxExemptForm.get('TaxIdentificationNumber').setValidators(Validators.required);
        this.taxExemptForm.get('TaxIdentificationNumber').updateValueAndValidity();
      }
    }
    if (this.taxExemptformObj) {
      this.taxExemptForm.patchValue({
        TaxIdentificationNumber: this.taxExemptformObj.TaxIdentificationNumber,
        CompanyName: this.taxExemptformObj.CompanyName,
        FirstName: this.taxExemptformObj.FirstName,
        MiddleName: this.taxExemptformObj.MiddleName,
        LastName: this.taxExemptformObj.LastName,
        Address: this.taxExemptformObj.Address,
        City: this.taxExemptformObj.City,
        State: this.taxExemptformObj.State,
        Zip: this.taxExemptformObj.Zip,
        CountryId: this.taxExemptformObj.CountryId,
        CellPhoneCountryId: this.taxExemptformObj.CellPhoneCountryId,
        CellPhone: this.taxExemptformObj.CellPhone,
        HomePhoneCountryId: this.taxExemptformObj.HomePhoneCountryId,
        HomePhone: this.taxExemptformObj.HomePhone,
        WorkPhoneCountryId: this.taxExemptformObj.WorkPhoneCountryId,
        WorkPhone: this.taxExemptformObj.WorkPhone,
        Email: this.taxExemptformObj.Email,
        FaxCountryId: this.taxExemptformObj.FaxCountryId,
        Fax: this.taxExemptformObj.Fax
      });
      this.getCountries();
      this.onCountryChange(this.taxExemptformObj.CountryId)
    } else {
      this.getCountry(this.defaultCountryId);
      this.getCountries();
    }
  }

  getMandatoryFields(componentName, formName: string) {
    this.generalService.GetMandatoryFields(this.facilityId, componentName, formName)
      .subscribe((response: IGetPermissionMandatoryField) => {
        this.taxValidators = response;
        this.setMandatoryFields(this.taxValidators, formName);
      });
  }

  setMandatoryFields(data, formName) {
    if (data.Form.ListOfProperties.length != 0) {
      data.Form.ListOfProperties.forEach(field => {
        if ((field.Name === 'CellPhone')) {
          if (field.Required) {
            this.taxExemptForm.get(field.Name).setValidators([this.cellPhoneValidator, Validators.required]);
          } else {
            this.taxExemptForm.get(field.Name).setValidators(this.cellPhoneValidator);
          }
        } else
          if (field.Name === 'Email') {
            if (field.Required) {
              this.taxExemptForm.get(field.Name).setValidators([Validators.pattern(this.emailPattern), Validators.required]);
            } else {
              this.taxExemptForm.get(field.Name).setValidators(Validators.pattern(this.emailPattern));
            }
          } else {
            if (field.Required) {
              this.taxExemptForm.get(field.Name).setValidators([Validators.required]);
            } else {
              this.taxExemptForm.get(field.Name).setValidators(null);
            }
          }
        this.taxExemptForm.get(field.Name).updateValueAndValidity();
      });
    }
    if (this.isDisableResellerPermit) {
      if (this.taxExemptForm) {
        this.taxExemptForm.get('TaxIdentificationNumber').patchValue('');
        this.taxExemptForm.get('TaxIdentificationNumber').disable();
        this.taxExemptForm.get('TaxIdentificationNumber').setValidators(null);
        this.taxExemptForm.get('TaxIdentificationNumber').updateValueAndValidity();
      }
    } else {
      if (this.taxExemptForm) {
        this.taxExemptForm.get('TaxIdentificationNumber').enable();
        this.taxExemptForm.get('TaxIdentificationNumber').setValidators(Validators.required);
        this.taxExemptForm.get('TaxIdentificationNumber').updateValueAndValidity();
      }
    }
  }

  public cellPhoneValidator(control: FormControl) {
    if ((control.value !== '') && (control.value !== null)) {
      const isWhitespace = (control.value).trim().length < 10;
      const isValid = !isWhitespace;

      return isValid ? null : { 'lessThanTen': true };
    }
  }

  isRequired(control) {
    if (this.taxExemptForm.get(control).validator !== null) {
      const validator = this.taxExemptForm.get(control).validator({} as AbstractControl);
      return validator && validator.required ? true : false;
    } else {
      return false
    }
  }

  positiveValue(val) {
    let id = parseInt(val, 10);
    if (!isNaN(id)) {
      if (id >= 0) {
        this.taxExemptForm.patchValue({
          TaxIdentificationNumber: id
        });
      } else {
        this.taxExemptForm.patchValue({
          TaxIdentificationNumber: null
        });
      }
    } else {
      this.taxExemptForm.patchValue({
        TaxIdentificationNumber: null
      });
    }
  }

  onCountryChange(obj) {
    if (obj == 1 || obj == 2) {
      this.emptyStateList = false;
      if (this.taxExemptformObj && this.taxExemptformObj.CountryId == obj) {
        this.taxExemptForm.patchValue({ State: this.taxExemptformObj.State });
      } else {
        this.taxExemptForm.patchValue({ State: '' });
      }
      this.taxExemptForm.get('State').enable();
      this.getStates(obj);
      this.getCountry(obj);
    } else {
      this.emptyStateList = true;
      this.stateList = [];
      this.taxExemptForm.patchValue({ State: '0' });
      this.taxExemptForm.get('State').disable();
      this.taxExemptForm.patchValue({
        CellPhoneCountryId: obj,
        HomePhoneCountryId: obj,
        WorkPhoneCountryId: obj,
        FaxCountryId: obj
      })
    }
  }

  getCountries() {
    if (this.userSessionService.countriesList.length) {
      this.countryList = this.userSessionService.countriesList;
    } else {
      this.generalService.getCountries().subscribe((response: ICountry[]) => {
        this.countryList = response;
        this.userSessionService.countriesList = response;
      });
    }
  }

  getCountry(id) {
    this.generalService.getCountry(id).subscribe((response: ICountry) => {
      this.defaultCountry = response.Id;
      this.taxExemptForm.patchValue({
        CountryId: this.defaultCountry,
        CellPhoneCountryId: this.defaultCountry,
        HomePhoneCountryId: this.defaultCountry,
        WorkPhoneCountryId: this.defaultCountry,
        FaxCountryId: this.defaultCountry
      });
      this.getStates(response.Id);
    });
  }

  getStates(id) {
    this.generalService.getStates(id).subscribe((response: IState[]) => {
      this.stateList = response;
    });
  }

  positiveValueZip(val) {
    let id = parseInt(val, 10);
    if (!isNaN(id)) {
      if (id >= 0) {
        this.taxExemptForm.patchValue({
          Zip: id
        });
      } else {
        this.taxExemptForm.patchValue({
          Zip: null
        });
      }
    } else {
      this.taxExemptForm.patchValue({
        Zip: null
      });
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
  }

  cancelForm(template: TemplateRef<any>) {
    if (this.taxExemptForm.dirty) {
      this.openModal(template);
    } else {
      this.taxExemptForm.reset();
      this.taxExemptForm.patchValue({ CellPhone: '' });
      this.taxExemptForm.patchValue({
        CountryId: this.defaultCountry,
        CellPhoneCountryId: this.defaultCountry,
        HomePhoneCountryId: this.defaultCountry,
        WorkPhoneCountryId: this.defaultCountry,
        FaxCountryId: this.defaultCountry
      });
      this.cancel.emit(true);
    }
  }

  clearForm() {
    this.taxExemptForm.reset();
    this.taxExemptForm.patchValue({ CellPhone: '' });
    this.taxExemptForm.patchValue({
      CountryId: this.defaultCountry,
      CellPhoneCountryId: this.defaultCountry,
      HomePhoneCountryId: this.defaultCountry,
      WorkPhoneCountryId: this.defaultCountry,
      FaxCountryId: this.defaultCountry
    });
    if (!this.taxExemptForm.valid) {
      this.cancel.emit(true);
    }
    this.modalRef.hide();
  }

  saveTaxExempt() {
    this.saveForm.emit(this.taxExemptForm.value)
  }

  allowOnly20() {
    if (this.taxExemptForm.get('TaxIdentificationNumber').value.toString().length > 20) {
      this.taxExemptForm.get('TaxIdentificationNumber').setValue('');
    }
  }

  allowOnly15() {
    if (this.taxExemptForm.get('Zip').value.toString().length > 15) {
      this.taxExemptForm.get('Zip').setValue('');
    }
  }

  getUserPermissions() {
    const userPermissions = this.generalService.getUserPermissionsForModule(EUserFunctions['Merchandise Sales : Sell Tax Free']);
    this.viewRight = userPermissions.ViewRight;
    this.viewRightFalseMessage = this.generalService.ViewRightFalseMessage;
    this.editRight = userPermissions.EditRight;
    this.editRightFalseMessage = this.generalService.EditRightFalseMessage;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.isDisableResellerPermit) {
      this.isDisableResellerPermit = changes.isDisableResellerPermit.currentValue;
    }
    if (this.isDisableResellerPermit) {
      if (this.taxExemptForm) {
        this.taxExemptForm.get('TaxIdentificationNumber').patchValue('');
        this.taxExemptForm.get('TaxIdentificationNumber').disable();
        this.taxExemptForm.get('TaxIdentificationNumber').setValidators(null);
        this.taxExemptForm.get('TaxIdentificationNumber').updateValueAndValidity();
      }
    } else {
      if (this.taxExemptForm) {
        this.taxExemptForm.get('TaxIdentificationNumber').enable();
        this.taxExemptForm.get('TaxIdentificationNumber').setValidators(Validators.required);
        this.taxExemptForm.get('TaxIdentificationNumber').updateValueAndValidity();
      }
    }

    if (changes.taxExemptformObj && changes.taxExemptformObj.currentValue) {
      this.taxExemptForm.patchValue({
        TaxIdentificationNumber: this.taxExemptformObj.TaxIdentificationNumber || '',
        CompanyName: this.taxExemptformObj.CompanyName || '',
        FirstName: this.taxExemptformObj.FirstName || '',
        MiddleName: this.taxExemptformObj.MiddleName || '',
        LastName: this.taxExemptformObj.LastName || '',
        Address: this.taxExemptformObj.Address || '',
        City: this.taxExemptformObj.City || '',
        State: this.taxExemptformObj.State || '',
        Zip: this.taxExemptformObj.Zip || '',
        CountryId: this.taxExemptformObj.CountryId || this.defaultCountry,
        CellPhoneCountryId: this.taxExemptformObj.CellPhoneCountryId || this.defaultCountry,
        CellPhone: this.taxExemptformObj.CellPhone || '',
        HomePhoneCountryId: this.taxExemptformObj.HomePhoneCountryId || this.defaultCountry,
        HomePhone: this.taxExemptformObj.HomePhone || '',
        WorkPhoneCountryId: this.taxExemptformObj.WorkPhoneCountryId || this.defaultCountry,
        WorkPhone: this.taxExemptformObj.WorkPhone || '',
        Email: this.taxExemptformObj.Email || '',
        FaxCountryId: this.taxExemptformObj.FaxCountryId || this.defaultCountry,
        Fax: this.taxExemptformObj.Fax || ''
      });
      this.taxExemptForm.markAsPristine();
      this.taxExemptForm.markAsUntouched();
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 46 || charCode > 57 || charCode == 47)) {
      return false;
    }
    return true;
  }

  alphaNumerics(event) {
    let k = this.commonMethodService.omit_special_char(event.charCode);
    return k;
  }
}
